// Core React
import React, { forwardRef } from 'react';
import { connect } from 'react-redux'

// 3rd party components
import { FixedSizeGrid } from 'react-window';
import AutoResizer from 'react-virtualized-auto-sizer';

// Redux slice
import { addPhotoToPool, chooseAllPhotos, unchooseAllPhotos } from 'components/collage/CollageSlice.js'

// Custom Components
import SelectablePhoto from './SelectablePhoto.js';

const GUTTER_SIZE = 5;
const PADDING_SIZE = window.innerWidth < 1024 ? 100 : 150;
 
class WindowedPhotoGrid extends React.Component {

  componentDidMount() {
    this._blockSize = this.props.collage.mode == 'sm' ? 135 : 123;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.collage.photos.num != nextProps.collage.photos.num;
  }

  render() {
    const nodeKeys    = Object.keys(this.props.collage.photos.nodes);
    const numColumns  = this.props.collage.mode == 'sm' ? 5 : 4;
    // const size        = (this.props.collage.mode == 'sm' ? (width / numColumns) : 123);

    // Pass the data source to the item renderer component as itemData:
    return (
      <AutoResizer>
        {({height, width}) => (
          <FixedSizeGrid
            itemData={nodeKeys}
            columnCount={numColumns}
            columnWidth={(this.props.collage.mode == 'sm' ? ((width - 40) / numColumns) : 123) + GUTTER_SIZE}
            height={height}
            innerElementType={innerElementType}
            rowCount={Math.ceil(nodeKeys.length / numColumns)}
            rowHeight={(this.props.collage.mode == 'sm' ? ((width - 40) / numColumns) : 123) + GUTTER_SIZE}
            width={width}
          >
            {ConnectedItemRenderer}
          </FixedSizeGrid>
        )}
      </AutoResizer>
    );
  }
}
 
// The item renderer is declared outside of the list-rendering component.
// So it has no way to directly access the data source.
class ItemRenderer extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.collage.photos.num != nextProps.collage.photos.num;
  }

  render() {
    const { columnIndex, data, rowIndex, style } = this.props;
    const src = data[(rowIndex * 4) + columnIndex];
 
    return (
      <div 
        style={{
          ...style,
          left: style.left + GUTTER_SIZE,
          top: style.top + GUTTER_SIZE,
          width: style.width - GUTTER_SIZE,
          height: style.height - GUTTER_SIZE,
          // top: `${parseFloat(style.top) + PADDING_SIZE}px`
        }}
      >
        {src &&
          <SelectablePhoto
            photo={this.props.collage.photos.nodes[src]}
            src={src}
          />
        }
      </div>
    );
  }
}

const innerElementType = forwardRef(({ style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{
      ...style,
      paddingLeft: GUTTER_SIZE,
      paddingTop: GUTTER_SIZE,
      height: `${parseFloat(style.height) + PADDING_SIZE * 2}px`
    }}
    {...rest}
  />
));

const mapStateToProps = state => ({
  collage: state.collage
});

const ConnectedItemRenderer = connect(
  mapStateToProps,
  null
)(ItemRenderer)

export default connect(
  mapStateToProps,
  { addPhotoToPool, chooseAllPhotos, unchooseAllPhotos }
)(WindowedPhotoGrid)